// make sure you update css when updating this media query
// app/stylesheets/trainer/modules/_queries.scss
const xs_screen = window.matchMedia("(max-width: 479px)")
const sm_screen = window.matchMedia("(max-width: 763px)")
const md_screen = window.matchMedia("(max-width: 1023px)")
const md_lg_only_screen = window.matchMedia("(min-width : 764px)")

export default {
  // https://github.com/Modernizr/Modernizr/blob/a0bab3c7bce629990acfaa67955632eeaee9f2e1/feature-detects/touchevents.js#L41
  is_touch_screen: () => (
    ("ontouchstart" in window) ||
    window.TouchEvent ||
    (window.DocumentTouch && document instanceof window.DocumentTouch) ||
    window.navigator.maxTouchPoints
  ),

  // return true if the screen width matches the size of a cellphone
  is_xs_screen: () => xs_screen.matches,

  // return true if the screen width matches the size of a small tablet
  is_sm_screen: () => sm_screen.matches,

  // triggers this callback every time it enters or leaves the media query
  on_sm_screen: (callback) => sm_screen.addListener(callback),

  // return true if the screen width matches the size of a tablet or smaller
  is_md_screen: () => md_screen.matches,

  // triggers this callback every time it enters or leaves the media query
  on_md_screen: (callback) => md_screen.addListener(callback),

  // return true if the screen width matches the size of a tablet or desktop
  is_md_lg_only_screen: () => md_lg_only_screen.matches
}
